export const translations = {
  en: {
    // Brand & General
    appName: "Sleeping Owls Gatepass",
    portalSubtitle: "Sleeping Owls Logistics Portal",
    rightsReserved: "Sleeping Owls Logistics Portal © 2026",
    cancel: "Cancel",
    save: "Save Changes",
    close: "Close",
    loading: "Loading...",
    others: "Others",
    enterName: "Enter Name",
    addItem: "Add Item",

    // Login Form
    loginPrompt: "Please enter passcode to continue",
    passcode: "Passcode",
    passcodePlaceholder: "••••",
    loginSecurely: "Login Securely",
    incorrectPasscode: "Incorrect passcode. Please try again.",

    // GatePassForm UI
    quickGatepass: "Quick Gatepass",
    gpNumber: "GP Number",
    partyName: "Party Name",
    enterPartyName: "Enter party name",
    salesChannel: "Sales Channel",
    selectChannel: "Select Channel",
    shippingMode: "Shipping Mode",
    selectMode: "Select Mode",
    approvedBy: "Approved By",
    selectApprover: "Select Approver",
    invoiceBy: "Invoice By",
    selectIssuer: "Select Issuer",
    comment: "Comment",
    addRemarks: "Add optional remarks...",
    itemsDetails: "Items Details",
    boxNo: "Box No.",
    itemName: "Item Name",
    packingStyle: "Packing",
    qty: "Qty",
    rate: "Rate",
    gst: "GST",
    action: "Action",
    addAnotherPackage: "Add Another Package",
    sleepingOwlsLogo: "Sleeping Owls Logo",
    printGatepass: "Print Gatepass",
    preparingPrint: "Preparing Print...",
    gatePassList: "Gate Pass List",
    analyticsReport: "Analytics Report",

    // Sales Channels Options
    factoryChannel: "Factory (Job work etc.)",
    indiamartChannel: "Indiamart/Retail/Whitelabelling",
    websiteChannel: "Website",
    operationsChannel: "Operations (Rajesh & Raj)",

    // Shipping Mode Options
    transportMode: "Transport",
    courierMode: "Courier",
    tempoMode: "Tempo / Porter",
    pickupMode: "Customer Pickup",

    // Quick Gatepass Modal
    quickGpTitle: "Quick Gatepass",
    quickGpInstructions: "Go to Vypaar ; Open Preview of Invoice ; Select All (Ctrl + A) ; Copy (Ctrl + C) ; Paste here (Ctrl + V) and click get Details button.",
    invoiceTextLabel: "Invoice Text",
    pasteInvoicePlaceholder: "Paste the invoice text here...",
    verifyItemsWarning: "Always verify the item details in next step before downloading the gatepass.",
    getDetails: "Get Details",
    parsing: "Parsing...",
    enterInvoiceAlert: "Please enter invoice text",
    parseSuccessAlert: "Successfully parsed! Found {count} items{company}.",

    // GatePassList UI
    createNewGp: "Create New GP",
    gatepassOverview: "Gatepass Management Overview",
    searchParty: "Search party...",
    searchGpNo: "GP No.",
    dateRange: "Date Range",
    to: "to",
    allChannels: "All Channels",
    allModes: "All Modes",
    shipping: "Shipping",
    clearFilters: "Clear Filters",
    showAllGatepasses: "Show All Gatepasses",
    showAllWarning: "Please avoid using this button too frequently, as it may exhaust the API limit.",
    deleteSelected: "Delete Selected",
    gpNoHeader: "GP No.",
    partyNameHeader: "Party Name",
    dateTimeHeader: "Date / Time",
    itemsHeader: "Items",
    docsHeader: "Docs",
    statusHeader: "Status",
    actionsHeader: "Actions",
    itemsCount: "{count} Items",
    downloadPdf: "Download PDF",
    packingSlip: "Packing Slip",
    duplicate: "Duplicate",
    edit: "Edit",
    pendingStatus: "Pending",
    deliveredStatus: "Delivered",
    pageIndicator: "Page {current} of {total}",
    noItemsAvailable: "No items available.",
    editGatePass: "Edit Gate Pass",
    date: "Date",
    deleteSuccess: "Successfully deleted selected gatepasses.",
  },
  hi: {
    // Brand & General
    appName: "स्लीपिंग आउल्स गेटपास",
    portalSubtitle: "स्लीपिंग आउल्स लॉजिस्टिक्स पोर्टल",
    rightsReserved: "स्लीपिंग आउल्स लॉजिस्टिक्स पोर्टल © 2026",
    cancel: "रद्द करें",
    save: "सहेजें",
    close: "बंद करें",
    loading: "लोड हो रहा है...",
    others: "अन्य",
    enterName: "नाम दर्ज करें",
    addItem: "सामान जोड़ें",

    // Login Form
    loginPrompt: "आगे बढ़ने के लिए कृपया पासकोड दर्ज करें",
    passcode: "पासकोड",
    passcodePlaceholder: "••••",
    loginSecurely: "सुरक्षित लॉगिन करें",
    incorrectPasscode: "गलत पासकोड। कृपया पुनः प्रयास करें।",

    // GatePassForm UI
    quickGatepass: "तेज़ गेटपास",
    gpNumber: "गेटपास नंबर",
    partyName: "पार्टी का नाम",
    enterPartyName: "पार्टी का नाम दर्ज करें",
    salesChannel: "बिक्री माध्यम",
    selectChannel: "माध्यम चुनें",
    shippingMode: "शिपिंग का प्रकार",
    selectMode: "प्रकार चुनें",
    approvedBy: "किसने बेचा",
    selectApprover: "स्वीकृतकर्ता चुनें",
    invoiceBy: "इनवॉइस कर्ता",
    selectIssuer: "जारीकर्ता चुनें",
    comment: "टिप्पणी / रिमार्क",
    addRemarks: "वैकल्पिक टिप्पणी जोड़ें...",
    itemsDetails: "सामान का विवरण",
    boxNo: "बॉक्स संख्या",
    itemName: "सामान का नाम",
    packingStyle: "पैकिंग",
    qty: "मात्रा",
    rate: "दर",
    gst: "जीएसटी",
    action: "कार्रवाई",
    addAnotherPackage: "एक और पैकेज जोड़ें",
    sleepingOwlsLogo: "स्लीपिंग आउल्स लोगो",
    printGatepass: "गेटपास प्रिंट करें",
    preparingPrint: "प्रिंट तैयार हो रहा है...",
    gatePassList: "गेटपास सूची",
    analyticsReport: "एनालिटिक्स रिपोर्ट",

    // Sales Channels Options
    factoryChannel: "फ़ैक्टरी (जॉब वर्क आदि)",
    indiamartChannel: "इंडियामार्ट/रिटेल/व्हाइटलेबलिंग",
    websiteChannel: "वेबसाइट",
    operationsChannel: "ऑपरेशन्स (राजेश और राज)",

    // Shipping Mode Options
    transportMode: "ट्रांसपोर्ट",
    courierMode: "कूरियर",
    tempoMode: "टैम्पो / पोर्टर",
    pickupMode: "कस्टमर पिकअप",

    // Quick Gatepass Modal
    quickGpTitle: "तेज़ गेटपास",
    quickGpInstructions: "व्यापार (Vypaar) पर जाएं ; इनवॉइस का पूर्वावलोकन खोलें ; सभी चुनें (Ctrl + A) ; कॉपी करें (Ctrl + C) ; यहाँ पेस्ट करें (Ctrl + V) और विवरण प्राप्त करें बटन पर क्लिक करें।",
    invoiceTextLabel: "इनवॉइस टेक्स्ट",
    pasteInvoicePlaceholder: "इनवॉइस टेक्स्ट यहाँ पेस्ट करें...",
    verifyItemsWarning: "गेटपास डाउनलोड करने से पहले हमेशा अगले चरण में सामान के विवरण की जांच करें।",
    getDetails: "विवरण प्राप्त करें",
    parsing: "विश्लेषण हो रहा है...",
    enterInvoiceAlert: "कृपया इनवॉइस टेक्स्ट दर्ज करें",
    parseSuccessAlert: "सफलतापूर्वक विश्लेषण किया गया! {count} सामान {company} मिला।",

    // GatePassList UI
    createNewGp: "नया गेटपास बनाएं",
    gatepassOverview: "गेटपास प्रबंधन विवरण",
    searchParty: "पार्टी खोजें...",
    searchGpNo: "गेटपास नं.",
    dateRange: "तारीख की सीमा",
    to: "से",
    allChannels: "सभी माध्यम",
    allModes: "सभी प्रकार",
    shipping: "शिपिंग",
    clearFilters: "फ़िल्टर हटाएं",
    showAllGatepasses: "सभी गेटपास दिखाएं",
    showAllWarning: "कृपया इस बटन का बार-बार उपयोग करने से बचें, क्योंकि यह API सीमा को समाप्त कर सकता है।",
    deleteSelected: "चयनित हटाएं",
    gpNoHeader: "गेटपास नं.",
    partyNameHeader: "पार्टी का नाम",
    dateTimeHeader: "तारीख / समय",
    itemsHeader: "सामान",
    docsHeader: "दस्तावेज़",
    statusHeader: "स्थिति",
    actionsHeader: "कार्रवाई",
    itemsCount: "{count} सामान",
    downloadPdf: "पीडीएफ डाउनलोड करें",
    packingSlip: "पैकिंग स्लिप",
    duplicate: "प्रतिलिपि बनाएं",
    edit: "संपादित करें",
    pendingStatus: "लंबित",
    deliveredStatus: "वितरित",
    pageIndicator: "पृष्ठ {current} में से {total}",
    noItemsAvailable: "कोई सामान उपलब्ध नहीं है।",
    editGatePass: "गेटपास संपादित करें",
    date: "तारीख",
    deleteSuccess: "चयनित गेटपास सफलतापूर्वक हटा दिए गए।",
  }
};
